/**
 * The empty-activity placeholders `create-empty` persists as an activity's real name and description.
 *
 * The server refuses a cover for an activity whose saved text still equals one of them, and the client skips its
 * automatic call in that case. Mirrors `Name` and `Description` of `EmptyActivityPlaceholders` in
 * `kt-services/src/Kt.Api/Domain/Activities/EmptyActivityPlaceholders.cs`. Keep both strings as plain single-quoted
 * literals: `EmptyActivityPlaceholdersTests` in `Kt.Api.UnitTests` reads this file back to catch a drift.
 */
export const COVER_PLACEHOLDER_TWIN = {
  NAME: 'Névtelen tevékenység',
  DESCRIPTION: 'Írd ide a tevékenység rövid leírását.',
} as const;
